import React from 'react';

/**
 * Shared page layout wrapper used by both SettingsLayout and AdminLayout.
 *
 * Renders a page title + description header, then a white card containing
 * the page content. The `compact` prop controls inner padding: Settings
 * pages use `p-3 sm:p-6` (tighter on mobile) while Admin pages use `p-6`.
 *
 * Extracted to eliminate the near-duplicate AdminLayout / SettingsLayout
 * components (audit finding F05).
 *
 * `actions` (optional) renders buttons at the right of the header, e.g. the
 * Developer API page's "API docs" / "Create key".
 */
export default function ShellPageLayout({ children, title, description, actions = null, compact = false }) {
    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex flex-wrap items-start gap-4">
                <div className="flex-1 min-w-[240px]">
                    <h1 className="text-2xl font-bold text-stone-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{title}</h1>
                    {description && <p className="text-stone-500 text-sm mt-1">{description}</p>}
                </div>
                {actions && <div className="flex items-center gap-2">{actions}</div>}
            </div>
            <div className="bg-white rounded-xl border border-stone-200 overflow-hidden">
                <div className={compact ? 'p-3 sm:p-6' : 'p-6'}>{children}</div>
            </div>
        </div>
    );
}
